package com.siriusxm.cmc.utils

public fun isValidGuid(guid: String): Boolean {
    val regex =
        Regex("^[{]?[0-9a-fA-F]{8}[-]?[0-9a-fA-F]{4}[-]?[0-9a-fA-F]{4}[-]?[0-9a-fA-F]{4}[-]?[0-9a-fA-F]{12}[}]?$")
    return regex.matches(guid)
}

private val typedEntityPrefixRegex = "^[A-Z]{2,4}$".toRegex()


/**
 * Is this a typed entity id
 */
public fun String?.isTypedEntity(): Boolean {
    val prefix = this?.substringBefore(":", "").orEmpty()
    return prefix.matches(typedEntityPrefixRegex)
}

/**
 * Is this a typed entity id list?
 */
public fun String?.isTypedEntityList(): Boolean {
    val typedEntityList = this?.toTypedEntityList()
    return !typedEntityList.isNullOrEmpty() && typedEntityList.size > 1
}

public fun String?.isGuidList(): Boolean {
    val guidList = this?.toGuidList()
    return !guidList.isNullOrEmpty() && guidList.size > 1
}

public fun String?.toGuidList(): List<String>? {
    val maybeGuids = this?.split(",")?.map { it.trim() }
    if (maybeGuids.isNullOrEmpty()) {
        return null
    }

    val guidList = maybeGuids.filter { isValidGuid(it) }
    if (guidList.isEmpty()) {
        return null
    }
    return guidList
}

/**
 * Is this a dot-delimited composite entity id, e.g.
 * "EntityImage.CHANNEL.f889faba-f9ff-ff9c-45d9-71d0f47770f1.TILE_CIRCLE.ASPECT_1_1.DEFAULT"?
 * These ids embed a GUID as one of their dot-separated segments, which a free-text search query
 * essentially never does, so this is used to route such ids straight to a lookup instead of search.
 */
public fun String?.isCompositeEntityId(): Boolean {
    val segments = this?.split(".") ?: return false
    return segments.size > 1 && segments.any { isValidGuid(it) }
}

/**
 * Convert a comma-separated list of typed entities into a list
 */
public fun String?.toTypedEntityList(): List<String>? {
    val maybeTypedEntities = this?.split(",")?.map { it.trim() }
    if (maybeTypedEntities.isNullOrEmpty()) {
        return null
    }

    val typedEntityIds = maybeTypedEntities.filter { it.isTypedEntity() }
    if (typedEntityIds.isEmpty()) {
        return null
    }
    return typedEntityIds
}